import type { MapMarkerIconProps } from "./map-marker-icon.type";

import {
  MarkerAsset,
  MarkerGroup,
  MarkerLocation,
  MarkerSector,
} from "@/modules/marker";

import { getMapMarkerIconGroupOptions } from "./map-marker-icon.helper";

const MapMarkerIcon = ({ marker }: MapMarkerIconProps) => {
  const { type, iconScale, iconColor } = marker;
  const { showGroup, count } = getMapMarkerIconGroupOptions(marker);

  if (showGroup) return <MarkerGroup count={count} />;

  if (type === "location") return <MarkerLocation scale={iconScale} />;

  if (type === "sector") return <MarkerSector scale={iconScale} />;

  if (type === "asset")
    return <MarkerAsset scale={iconScale} color={iconColor} />;

  return null;
};

export default MapMarkerIcon;
